import { z } from 'zod';

import { type UpdateCustomerProfilePayload } from '@/modules/api';
import { isLegalKeyAgreed, type LegalDocumentGroup } from '@/modules/legalDocuments';
import { formatBirthdayForData, getServerLocale, getSystemLocale } from '@/modules/localization';

import { LEGAL_KEY } from '../constants';
import { accountSchema } from '../schema/accountSchema';

type FormValues = z.infer<typeof accountSchema>;

export const buildUpdateCustomerProfilePayload = (
  customerProfileUri: string,
  values: FormValues,
  legalGroups: LegalDocumentGroup[]
): UpdateCustomerProfilePayload => {
  return {
    customerProfileUri,
    customerProfile: {
      birthday: formatBirthdayForData(values.birthday),
      // SSO users don't see the SMS checkbox — default to false.
      smsAllowed: values.sms ?? false,
      termsAndConditionsAccepted: isLegalKeyAgreed(values.agreements, legalGroups, LEGAL_KEY.TERMS),
      informedConsentAccepted: isLegalKeyAgreed(values.agreements, legalGroups, LEGAL_KEY.CONSENT),
      preferredLanguage: getServerLocale(getSystemLocale()),
    },
  };
};
